import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function IsDealerConfiguratorAnd({ children, dealerOrderTypes }) {
  const {
    isDealerConfigurator,
    order
  } = useContext(ConfiguratorContext)

  const orderDealerOrderType = order.dealer_order_type ?? ''

  if (!isDealerConfigurator || !dealerOrderTypes.includes(orderDealerOrderType)) {
    return null
  }

  return <>{children}</>
}
